<div>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body">
    @if (!messagesCancelled) {
      <div>
        <p>You are about to cancel the processing of the following:</p>
        @if (interchangeInIds.length > 0) {
          <p>Interchange In: {{interchangeInIds.length}}</p>
        }
        @if (documentIds.length > 0) {
          <p>Documents: {{documentIds.length}}</p>
        }
        @if (interchangeOutIds.length > 0) {
          <p>Interchange Out: {{interchangeOutIds.length}}</p>
        }
      </div>
    }
    @if (messagesCancelled) {
      <div>
        <p>Messages have been marked for cancellation.</p>
        <p>They will not change status before reaching a step that will cancel the processing.</p>
        <p></p>
        <p>Got to the status page to monitor the cancelled messages.<p>
        </div>
      }
    </div>
    <div class="modal-footer">
      @if (!messagesCancelled) {
        <button type="button" class="btn btn-primary" (click)="cancelMessage()">Cancel messages</button>
      }
      @if (messagesCancelled) {
        <button type="button" class="btn btn-primary" (click)="goToCancelledMessages()">Go to cancelled messages</button>
      }
      <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
    </div>
  </div>